module.exports = __webpack_public_path__ + "static/media/user.a0908a30.png";